export const disableCommercial = () => {
  const today = new Date().toISOString().split('T')[0];
  const unavailableDates = ['2024-01-26'];

  return unavailableDates.includes(today);
};
